import { render, staticRenderFns } from "./SettingDrawer.vue?vue&type=template&id=4ed287ff&scoped=true&"
import script from "./SettingDrawer.vue?vue&type=script&lang=ts&"
export * from "./SettingDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./SettingDrawer.vue?vue&type=style&index=0&id=4ed287ff&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed287ff",
  null
  
)

export default component.exports